import { Box, Grid } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { DAY_GROUP } from "@shared/client";
import { FLEX, FONT } from "@styles/common";

export const Days = () => {
    return (
        <Grid width="100%" gridTemplateColumns="repeat(7,1fr)">
            {DAY_GROUP.map((day) => {
                return (
                    <CustomBox
                        key={day.id}
                        textAlign="center"
                        day={day.id}
                        _first={{ borderLeft: "none" }}
                        _last={{ borderRight: "none" }}
                    >
                        {day.title}
                    </CustomBox>
                );
            })}
        </Grid>
    );
};

const CustomBox = styled(Box)<{ day: string }>`
    ${FLEX.normal("center", "center")}
    height: 48px;
    padding: 10px;
    box-sizing: border-box;
    ${FONT("pretendard", 16, 500, 1)}
    color : ${({ theme, day }) => {
        const isSaturday = day === "SAT";
        const isSunday = day === "SUN";

        if (isSaturday) return theme.COLOR.blue[300];
        if (isSunday) return theme.COLOR.pink[200];

        return theme.COLOR.black;
    }};
    border-left: 1px solid ${({ theme }) => theme.COLOR.gray[300]};
`;
